import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { css } from 'glamor';
var Alert = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Alert, _React$PureComponent);
  var _super = _createSuper(Alert);
  function Alert(props) {
    var _this;
    _classCallCheck(this, Alert);
    _this = _super.call(this, props);
    _this.containerStyle = css({
      borderRadius: '3px',
      backgroundColor: '#fff',
      padding: '10px 16px',
      display: 'flex',
      boxSizing: 'border-box',
      boxShadow: 'rgba(67, 90, 111, 0.3) 0px 0px 1px, rgba(67, 90, 111, 0.47) 0px 8px 10px -4px',
      justifyContent: 'space-between',
      flexDirection: 'row'
    });
    _this.containerBorderSuccess = css({
      borderLeft: '3px solid rgb(71, 184, 129)'
    });
    _this.containerBorderWarn = css({
      borderLeft: '3px solid rgb(217, 130, 43)'
    });
    _this.containerBorderDanger = css({
      borderLeft: '3px solid rgb(236, 76, 71)'
    });
    _this.containerBorderNotify = css({
      borderLeft: '3px solid rgb(16, 112, 202)'
    });
    _this.toastTextTitle = css({
      fontWeight: '600',
      fontSize: '14px',
      color: '#435a6f',
      margin: '0'
    });
    _this.toastTextChild = css({
      fontSize: '14px',
      color: '#999',
      margin: '0'
    });
    _this.toastClose = css({
      marginLeft: '15px',
      height: '24px',
      width: '24px',
      lineHeight: '22px',
      fontWeight: '700',
      textAlign: 'center',
      fontSize: '20px',
      color: '#000',
      cursor: 'pointer',
      opacity: '0.5',
      ':hover': {
        opacity: 1
      }
    });
    _this.toastIcon = css({
      marginRight: '10px',
      width: '14px',
      height: '20px',
      lineHeight: '20px'
    });
    return _this;
  }
  _createClass(Alert, [{
    key: "getContainerStyle",
    value: function getContainerStyle(intent) {
      switch (intent) {
        case 'success':
          return {
            borderStyle: this.containerBorderSuccess,
            iconColor: css({
              color: 'rgb(71, 184, 129)'
            }),
            iconClass: 'iconfont icon-check-circle'
          };
        case 'warning':
          return {
            borderStyle: this.containerBorderWarn,
            iconColor: css({
              color: 'rgb(217, 130, 43)'
            }),
            iconClass: 'iconfont icon-exclamation-triangle'
          };
        case 'none':
          return {
            borderStyle: this.containerBorderNotify,
            iconColor: css({
              color: 'rgb(16, 112, 202)'
            }),
            iconClass: 'iconfont icon-exclamation-circle'
          };
        case 'danger':
          return {
            borderStyle: this.containerBorderDanger,
            iconColor: css({
              color: 'rgb(236, 76, 71)'
            }),
            iconClass: 'iconfont icon-exclamation-circle'
          };
        default:
          return {
            borderStyle: this.containerBorderNotify,
            iconColor: css({
              color: 'rgb(16, 112, 202)'
            }),
            iconClass: 'iconfont icon-exclamation-circle'
          };
      }
    }
  }, {
    key: "render",
    value: function render() {
      var toastStyle = this.getContainerStyle(this.props.intent);
      return /*#__PURE__*/React.createElement("div", css(toastStyle.borderStyle, this.containerStyle), /*#__PURE__*/React.createElement("div", {
        className: this.toastIcon
      }, /*#__PURE__*/React.createElement("i", Object.assign({
        className: toastStyle.iconClass
      }, toastStyle.iconColor))), /*#__PURE__*/React.createElement("div", {
        className: this.toastTextContainer
      }, /*#__PURE__*/React.createElement("p", {
        className: this.toastTextTitle
      }, this.props.title), this.props.children ? /*#__PURE__*/React.createElement("p", {
        className: this.toastTextChild
      }, this.props.children) : null), /*#__PURE__*/React.createElement("div", {
        onClick: this.props.onRemove,
        className: this.toastClose
      }, /*#__PURE__*/React.createElement("span", null, "\xD7")));
    }
  }]);
  return Alert;
}(React.PureComponent);
export default Alert;